// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import React, { Component, PropTypes } from 'react';
import { observer } from 'mobx-react';

import Chart from 'share/components/charting/Izenda.Chart';
import ChartToolbar from '../Izenda.ChartToolbar';

import { parser as chartDataParser } from 'share/utils/Izenda.ChartDataParser';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import { getOr, get, merge } from 'lodash/fp';

@observer
export default class ChartPreview extends Component {
  static propTypes = {
    reportPart: PropTypes.object.isRequired
  };

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    this.props.updateDrillComponent.call(this);
    this.props.setDefaultIntervalForDatetime.call(this);
  }

  componentDidUpdate() {
    this.props.updateDrillComponent.call(this);
    this.props.setDefaultIntervalForDatetime.call(this);
  }

  getChartProperties(props) {
    const reportPart = props.reportPart || {};
    const reportPartContent = reportPart.reportPartContent;
    let chartProperties = reportPart.getReportPartProperties() || {};
    const printingMode = props.printingMode;
    const sortLinear = props.getSortValueForLinearChart();
    const sortDrilldown = get('currentDrilldownField.properties.dataFormattings.sort', reportPartContent);
    const currentAnimation = getOr(false, 'commonOptions.plotOptions.series.animation', chartProperties);

    if (printingMode && !currentAnimation) {
      chartProperties.commonOptions = merge(chartProperties.commonOptions, {
        plotOptions: {
          series: {
            animation: false
          }
        }
      });
    }
    chartProperties = merge(chartProperties, {
      colors: reportPart.getThemeColors(chartProperties),
      commonActions: {
        onDrilldown: props.onDrilldown,
        setPageSize: props.setPageSize,
        pointAction: props.pointAction,
        drillOnOthersPeace: props.drillOnOthersPeace
      },
      sort: {
        valueXAxisForLinear: sortLinear,
        valueXAxisDrilldown: sortDrilldown,
        chartType: chartProperties.chartType
      }
    });
    return chartProperties;
  }

  render() {
    const props = this.props;
    const reportPart = props.reportPart || {};
    const reportPartContent = reportPart.reportPartContent;
    const type = reportPartContent.type;
    const chartProperties = this.getChartProperties(this.props);
    const printingMode = props.printingMode;
    const doesBreakPage = reportPartContent.checkBreakPage();
    const doesShowChartToolBar =
      reportPartContent.isShowMetric || reportPartContent.isShowBreadcrumb || !props.hideGridPopup;

    const chartData = chartDataParser(reportPartContent.activeElmsByContainers, reportPartContent.expandedLevel, {
      fieldsMapping: reportPart.previewDataFieldsMapping,
      records: reportPart.previewDataRecords,
      rawData: reportPart.previewData
    });

    // refresh data intervals
    props.refreshData && props.refreshData(true);

    if (ReportPartUtils.needToRenderLazyLoadingBar(props.reportPart, props.printingMode)) {
      return ReportPartUtils.renderLazyLoadingBar();
    }

    return (
      <Chart
        reportPart={reportPart}
        isPreview={props.isPreview}
        type={type}
        chartType={chartProperties.chartType}
        vizEngine={reportPartContent.vizEngine}
        chartOptions={chartProperties}
        seriesOptions={props.reportPart.fieldCollection}
        chartData={chartData}
        viewMode={props.viewMode}
        printingMode={printingMode}
        style={printingMode && props.style ? props.style : {}}
        finishedRender={props.finishedRender}
        fulfilledData={props.fulfilledData}
        containerSize={props.containerSize}
        isLoading={reportPart.isLoadingData}
        doesBreakPage={!props.forDashboard && doesBreakPage && !props.embededReportPart}
        separator={props.separator}
        elementsCountInContainer={props.elementsCountInContainer}
        pageNumber={props.pageNumber}
        forExporting={props.forExporting}
      >
        {!printingMode &&
          doesShowChartToolBar && (
            <ChartToolbar
              hideGridPopup={props.hideGridPopup}
              reportPart={reportPart}
              onDrillDown={props.onDrilldown}
              isShowMetric={reportPartContent.isShowMetric}
              isShowBreadcrumb={reportPartContent.isShowBreadcrumb}
            />
          )}
      </Chart>
    );
  }

  componentWillUnmount() {
    this.props.refreshData && this.props.refreshData(false);
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.ChartPreview.js